<template>
  <div>
    <el-upload
      ref="upload"
      :data="uploadData"
      :action="action"
      :on-preview="onPreview"
      :before-remove="beforeRemove"
      :on-success="onSuccess"
      multiple
      :file-list="uploadFileList"
      :auto-upload="false">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="$refs.upload.submit()">上传到服务器</el-button>
      <div slot="tip" class="el-upload__tip">{{ tip }}</div>
    </el-upload>
  </div>
</template>

<script>
  export default {
    props: {
      fileList: {
        default: []
      },
      action: {
        default: ''
      },
      delUrl: {
        default: ''
      },
      data: {},
      tip: {
        default: ''
      }
    },
    data() {
      return {
        uploadFileList: this.fileList || [],
      }
    },
    computed: {
      uploadData: function() {
        this.data.token = this.$store.state.user.token;
        return this.data;
      }
    },
    methods: {
      beforeRemove(file, fileList) {
        if(file.status == 'success') {
          this.confirm('确定删除已上传的文件【' + file.name + '】吗？请谨慎操作，不可恢复！', () => {
            let postData = this._.cloneDeep(this.data);
            postData.file_id = parseInt(file.id);
            this.post(this.delUrl, postData).then(resp => {
              if (resp) {
                if(resp.data['success']) {
                  let index = fileList.indexOf(file);
                  if (index !== -1) {
                    fileList.splice(index, 1);
                  }
                  this.success(resp.data['msg']);
                }
              }
            });
          });
          return false;
        }
        return true;
      },
      onPreview(file) {
        window.open(`${this.CX_API_ROOT}/${file.path}?token=${this.data.token}`);
      },
      onSuccess(resp, file, fileList) {
        if (resp.success) {
          if(resp.obj) {
            file.path = resp.obj.path;
            file.id = resp.obj.id;
          }
          this.success(resp.msg);
        } else {
          file.status = 'ready';
        }
      },
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxUploadFiles.vue